<template>
  <v-app-bar color="white" app hide-on-scroll :height="100">
    <router-link to="/" replace>
      <v-toolbar-title class="text-h5 text-uppercase">
        <v-img
          src="img/total.svg"
          height="100"
          max-width="200"
          contain
          position="center"
        />
      </v-toolbar-title>
    </router-link>
    <v-spacer></v-spacer>
    <router-link to="/" replace>
      <v-toolbar-title class="text-h5 text-uppercase">
        <v-img
          src="img/logo.svg"
          height="100"
          max-width="200"
          contain
          position="center"
          class="mx-5"
        />
      </v-toolbar-title>
    </router-link>
    <v-spacer></v-spacer>
    <div>
      <v-btn class="guidebook">
        <a
          style="color: white"
          class="guidebookLink"
          target="_blank"
          :href="getWorkbookPath()"
          >{{ $t("commons.download_guidebook") }}</a
        >
      </v-btn>
    </div>
    <v-spacer></v-spacer>
    <!-- LOCALE -->
    <v-menu absolute>
      <template v-slot:activator="{ on: on_menu }">
        <v-tooltip bottom open-delay="500">
          <template v-slot:activator="{ on: on_tooltip }">
            <v-btn
              icon
              v-on="{ ...on_menu, ...on_tooltip }"
              class="blue--text text--darken-4"
            >
              <span>{{ locales[$i18n.locale].label }}</span>
            </v-btn>
          </template>
          <span>{{ $t("app.toolbar.language.tooltip") }}</span>
        </v-tooltip>
      </template>
      <v-list dense>
        <v-list-item
          v-for="(value, name) in locales"
          :key="name"
          @click="$i18n.locale = name"
        >
          <v-list-item-subtitle>
            <span class="blue--text text--darken-4">{{ value.label }}</span>
          </v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- Versions -->
    <div>
      <v-tooltip bottom open-delay="500">
        <template v-slot:activator="{ on: on_tooltip }">
          <v-btn
            @click.native="openDialog('versions')"
            icon
            v-on="{ ...on_tooltip }"
            class="blue--text text--darken-4"
          >
            <v-icon>mdi-history</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("app.toolbar.versions") }}</span>
      </v-tooltip>
    </div>
    <div v-if="getUserRole.toUpperCase() === 'ADMIN'">
      <v-tooltip bottom open-delay="500">
        <template v-slot:activator="{ on: on_tooltip }">
          <v-btn
            @click.native="openDialog('download')"
            icon
            v-on="{ ...on_tooltip }"
            class="blue--text text--darken-4"
          >
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("app.toolbar.export_analytics") }}</span>
      </v-tooltip>
    </div>
    <!-- CONTACT -->
    <div v-show="cguAccepted">
      <v-tooltip bottom open-delay="500">
        <template v-slot:activator="{ on: on_tooltip }">
          <v-btn
            @click.native="openDialog('contact')"
            icon
            v-on="{ ...on_tooltip }"
            class="blue--text text--darken-4"
          >
            <v-icon>mdi-at</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("app.toolbar.contact.tooltip") }}</span>
      </v-tooltip>
    </div>
    <!-- LEGAL TERMS -->
    <div v-show="cguAccepted">
      <v-tooltip bottom open-delay="500">
        <template v-slot:activator="{ on: on_tooltip }">
          <v-btn
            icon
            @click.native="openDialog('legal')"
            v-on="{ ...on_tooltip }"
            class="blue--text text--darken-4"
          >
            <v-icon>mdi-shield-account-outline</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("app.toolbar.legal.tooltip") }}</span>
      </v-tooltip>
    </div>
    <!-- VIDEO -->
    <v-menu absolute>
      <template v-slot:activator="{ on: on_menu }">
        <v-tooltip bottom open-delay="500">
          <template v-slot:activator="{ on: on_tooltip }">
            <v-btn
              icon
              v-on="{ ...on_menu, ...on_tooltip }"
              class="blue--text text--darken-4"
            >
              <FontIcon>slideshow</FontIcon>
            </v-btn>
          </template>
          <span>{{ $t("app.toolbar.video.tooltip") }}</span>
        </v-tooltip>
      </template>
      <v-list dense>
        <v-list-item v-for="video in videos" :key="video.key">
          <v-list-item-subtitle
            class="video-selector"
            @click.stop="() => selectVideo(video.key)"
          >
            <span class="blue--text text--darken-4">{{ $t(video.label) }}</span>
            <!--<span class="flag-icon" v-bind:class="[value.class]"></span>-->
          </v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- LOGOUT -->
    <v-tooltip bottom open-delay="500">
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          v-on="on"
          @click="logout"
          v-show="true"
          class="blue--text text--darken-4"
        >
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("app.toolbar.logout.tooltip") }}</span>
    </v-tooltip>
    <div :style="{ width: '106px' }"></div>
    <SetProject v-if="cguAccepted" />
    <div class="dialog-hider">
      <DialogWrapper
        :dialog="dialogs.versions"
        @click-outside="dialogs.versions = false"
        @close-dialog="dialogs.versions = false"
        :title="$t('app.toolbar.versions')"
      >
        <div>
          {{ $t("app.versions") }}
          <div>{{ $t("version.releaseNote") }}:</div>
          <v-row no-gutters v-for="(v, i) in versions" :key="i">
            <li>
              <a :href="getPathName(v)">{{ v }}</a>
            </li>
          </v-row>
        </div>
      </DialogWrapper>
      <div>
        <DialogWrapper
          :dialog="dialogs.download"
          @click-outside="dialogs.download = false"
          @close-dialog="dialogs.download = false"
          :title="download"
        >
          <div>
            <h1>{{ $t("app.toolbar.export_analytics") }}</h1>
          </div>
          <v-row justify="center">
            <v-col cols="12">
              <v-select
                v-model="selectedYear"
                :items="years"
                label="Select Year"
                class="centered-select"
              ></v-select>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col cols="12">
              <v-select
                v-model="selectedMonth"
                :items="months"
                label="Select Month"
                item-text="value"
                item-value="id"
                class="centered-select"
              ></v-select>
            </v-col>
          </v-row>

          <v-btn :loading="dataIsLoading" @click="exportAnalytics"
            ><h2>{{ $t("app.toolbar.export_analytics") }}</h2></v-btn
          >
        </DialogWrapper>
      </div>
      <DialogWrapper
        :dialog="dialogs.contact"
        @click-outside="dialogs.contact = false"
        @close-dialog="dialogs.contact = false"
        :title="$t('app.toolbar.contact.tooltip')"
      >
        <div v-html="$t('app.contact')"></div>
      </DialogWrapper>
      <DialogWrapper
        :dialog="dialogs.legal"
        @click-outside="dialogs.legal = false"
        @close-dialog="dialogs.legal = false"
        :title="$t('cgu.title').toString()"
      >
        <div class="border mx-5 mt-5 cgu-body">
          <div v-html="getHtml"></div>
        </div>
      </DialogWrapper>
    </div>

    <ScenarioProjectHeader v-if="onStepPage" />
  </v-app-bar>
</template>

<script lang="ts">
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import SetProject from '@/components/Projects/SetProject.vue';
import FontIcon from '@/components/FontIcon.vue';
import VideoTrigger from '@/components/Mixins/VideoTrigger.vue';
import DialogWrapper from '@/components/DialogWrapper.vue';
import _versions from '@/helpers/versionsHelper';
import VersionMixin from '@/components/Mixins/VersionMixin.vue';
import ScenarioProjectHeader from '@/components/ScenarioProjectHeader.vue';
import { EventBus, EventBusEvents } from '@/helpers/event-bus';

@Component({
  components: {
    ScenarioProjectHeader,
    SetProject,
    FontIcon,
    DialogWrapper
  }
})
export default class AppHeader extends Mixins(VideoTrigger, VersionMixin) {
  @Prop({ type: [Boolean], default: () => true })
  public cguAccepted!: boolean;

  @Prop({ default: () => null })
  public htmlContent: any;

  private versions = _versions;

  private selectedYear: number | null = null;
  private selectedMonth: string | null = null;
  private locales: any = {
    en: {
      label: 'EN'
    },
    fr: {
      label: 'FR'
    }
  };

  private dialogs: any = {
    contact: false,
    legal: false,
    help: false,
    versions: false,
    download: false
  };

  private cguLastPath: any = {
    fr: '/cgus/CGU_last.fr.html',
    en: '/cgus/CGU_last.en.html'
  };

  private videos: { key: string; label: string }[] = [
    { key: 'dashboard.header.video', label: 'commons.video.home' },
    { key: 'dashboard.list.video', label: 'commons.video.welcome' }
  ];

  // COMPUTED =======================================================
  get legalDialog(): boolean {
    return this.dialogs.legal;
  }

  get downloadDialog(): boolean {
    return this.dialogs.download;
  }

  get getLocale(): string {
    return this.$i18n.locale;
  }

  get years(): number[] {
    const years = [];
    for (let year = 2020; year <= 2030; year++) {
      years.push(year);
    }
    return years;
  }

  get months(): { id: number; value: string }[] {
    return [
      { id: 1, value: 'January' },
      { id: 2, value: 'February' },
      { id: 3, value: 'March' },
      { id: 4, value: 'April' },
      { id: 5, value: 'May' },
      { id: 6, value: 'June' },
      { id: 7, value: 'July' },
      { id: 8, value: 'August' },
      { id: 9, value: 'September' },
      { id: 10, value: 'October' },
      { id: 11, value: 'November' },
      { id: 12, value: 'December' }
    ];
  }

  get dataIsLoading(): boolean {
    return this.$store.getters['report/getDataIsLoading'];
  }

  get getUserRole(): boolean {
    return this.$store.getters['user/getUserRole'];
  }

  get getCGUPath(): string {
    return this.cguLastPath[this.getLocale];
  }
  get getHtml(): any {
    return this.$store.getters['cgu/getCGUAll'][this.getLocale];
  }

  get onStepPage(): boolean {
    return this.$route.path.startsWith('/scenario');
  }

  // METHODS =======================================================
  private openDialog(name: string) {
    EventBus.$emit(EventBusEvents.killVideo);
    this.dialogs[name] = true;
  }

  private logout() {
    this.$store.dispatch('user/logout');
  }

  private getWorkbookPath() {
    return `documentation/HySize Guidebook.pdf`;
  }

  private selectVideo(value: string) {
    this.localeVideoKey = value;
    this.onVideoTrigger();
  }

  private clearSelection() {
    this.selectedMonth = null;
    this.selectedYear = null;
  }

  private async exportAnalytics() {
    try {
      const year = this.selectedYear;
      const month = this.selectedMonth;
      if (year !== null && month !== null) {
        await this.$store.dispatch('report/ExportAnalytics', {
          year,
          month
        });
      }
    } catch (error) {
      console.log('Error while downloading');
    }
  }

  // HOOKS =======================================================
  @Watch('legalDialog', { immediate: true })
  private onLegalDialogChange() {
    if (this.legalDialog) {
      this.$store.dispatch('cgu/getLastCguPage', {
        path: this.getCGUPath,
        locale: this.getLocale
      });
    }
  }

  @Watch('downloadDialog', { immediate: true })
  private onDownloadDialogChange() {
    if (this.downloadDialog) {
      this.clearSelection();
    }
  }
}
</script>

<style lang="stylus">
.border {
  border: 1px solid #00000055;
}

.video-selector {
  cursor: pointer;
}

.centered-select .v-list-item__title {
  text-align: center;
}

.guidebook {
  background-color: rgb(234, 73, 123) !important;
  color: white !important;
  border-radius: 5px;
  padding: 5px;
}

.guidebookLink {
  text-decoration: none;
}
</style>
